import { useQuery } from '@tanstack/react-query';
import { queryKeys, type QueryConfig } from '@/lib/query';
import { reportService } from '../services/reportService';
import type { ReportCategory } from '../types/report';

export function usePermittedReports(
  moduleId: string,
  config?: QueryConfig<ReportCategory[]>,
) {
  return useQuery({
    queryKey: queryKeys.reports.permitted(moduleId),
    queryFn: () => reportService.getPermittedReports(moduleId),
    enabled: !!moduleId,
    refetchOnMount: 'always',
    staleTime: 0,
    ...config,
  });
}
